const services = Object.freeze({
  customer: 'AI Customer Service', voice: 'Voice & Digital Human',
  sales: 'Sales & Lead Automation', knowledge: 'Knowledge & Document AI',
  operations: 'Workflow Automation', connected: 'Enterprise Agentic Systems',
  horizon: 'AI-Native Websites & Search Growth'
});
const servicePaths = Object.freeze({
  '/pages/ai-customer-service':'customer', '/pages/voice-digital-human':'voice',
  '/pages/sales-lead-automation':'sales', '/pages/knowledge-document-ai':'knowledge',
  '/pages/workflow-automation':'operations', '/pages/enterprise-agentic-systems':'connected',
  '/pages/ai-native-websites-search-growth':'horizon'
});
export const entryPoints = Object.freeze(['home','solutions','horizon-proof',...Object.keys(services).map(s=>'service-'+s)]);
export function portfolioContext(search='') {
  const params=new URLSearchParams(search);
  return {solution:Object.hasOwn(services,params.get('solution'))?params.get('solution'):'',
    entry:entryPoints.includes(params.get('entry'))?params.get('entry'):''};
}
export function mountPortfolio(){
  const horizon=document.querySelector('[data-horizon]');
  if(horizon){
    const tabs=[...horizon.querySelectorAll('[data-horizon-step]')];
    const panels=[...horizon.querySelectorAll('[data-horizon-panel]')];
    function select(index,focus=false){
      horizon.dataset.stage=String(index);
      tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
      if(focus)tabs[index].focus();
    }
    panels.forEach((panel,i)=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[i].id);panel.tabIndex=0;});
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>select(i));
      tab.addEventListener('keydown',event=>{
        const moves={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1};
        if(Object.hasOwn(moves,event.key)){event.preventDefault();select(moves[event.key],true);}
      });
    });
    horizon.classList.add('horizon-enhanced');select(0);horizon.querySelector('[role=tablist]').hidden=false;
    const intentions=horizon.querySelector('.horizon-intentions');
    if(intentions){
      const choices=[...intentions.querySelectorAll('input[type=radio]')];
      const directions=[...horizon.querySelectorAll('[data-horizon-direction]')];
      function choose(value,announce=false){
        directions.forEach(panel=>{
          const active=panel.dataset.horizonDirection===value;
          panel.setAttribute('aria-hidden',String(!active));
          panel.inert=!active;
        });
        if(announce){
          const active=directions.find(panel=>panel.dataset.horizonDirection===value);
          horizon.querySelector('.horizon-announcement').textContent=active.querySelector('.horizon-interpretation h4').textContent+' '+active.querySelector('.horizon-choice-reason').textContent;
        }
      }
      choices.forEach(choice=>choice.addEventListener('change',()=>{if(choice.checked)choose(choice.value,true);}));
      choose(choices.find(choice=>choice.checked).value);
      horizon.classList.add('horizon-meaning-enhanced');
      intentions.hidden=false;
    }
  }
  const context=portfolioContext(location.search);
  const currentEntry=servicePaths[location.pathname]?'service-'+servicePaths[location.pathname]:({'/':'home','/pages/solutions':'solutions'}[location.pathname]||'');
  if(currentEntry)document.querySelectorAll('a[href]').forEach(a=>{
    const url=new URL(a.href,location.origin);
    if(url.origin===location.origin&&['/pages/contact','/pages/ai-opportunity-scan'].includes(url.pathname)&&!url.searchParams.has('entry')){
      url.searchParams.set('entry',currentEntry);a.setAttribute('href',url.pathname+url.search+url.hash);
    }
  });
  const entry=document.getElementById('lead-entry');
  if(entry)entry.value=context.entry;
  const scanContext=document.querySelector('[data-g5-scan-context]');
  if(scanContext&&context.solution){
    scanContext.hidden=false;
    scanContext.querySelector('[data-g5-interest]').textContent=services[context.solution];
    const direct=scanContext.querySelector('a');
    direct.href='/pages/contact?'+new URLSearchParams({solution:context.solution,...(context.entry?{entry:context.entry}:{})});
  }
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountPortfolio,{once:true});
  else mountPortfolio();
}
